module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OddD6U/tc-custom/9780062046253.jpg?1733089179547",
      "alt": "This image is the cover for the book Life Worth Living"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Life Worth Living\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Inspirational and heartwarming, "), _c('i', [_vm._v("A Life Worth Living")]), _vm._v(" provides a insightful guide to living life meaningfully and well. In a time when everyday life is dominated by the pursuit of material wealth, Dr. Barrie Sanford Greiff has redefined \"net worth\" as a life not dominated by the financial bottom line. Weaving together memorable stories and insights gathered during his long tenure as a Harvard psychiatrist, Greiff highlights in this though-provoking book nine essentials that make true worth: Loving, Learning, Laboring, Laughing, Lamenting, Linking, Living, Leading and Leaving. By heightening our awareness of these essentials in our lives, he reasons, we can find the path to spiritual worth -- and learn that sharing life lessons is the best way to make our lives worthwhile. Both pragmatic and uplifting,"), _c('i', [_vm._v(" A Life Worth Living")]), _vm._v(" offers an inspiring remedy for the spiritual myopia of our time.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Barrie Sanford Greiff\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("  Barrie Sanford Greiff, M.D. is a psychiatric consultant to the Harvard University Heath Services. He has consulted for a wide range of organizations from Fortune 500 Companies to privately helf family business. For almost two decades he was the pychiatrist to the Harvard Business School, where he pioneered a unique course dealing with the juggling of self, family, and work life. He has lectured nationally and conducts a consulting practice in Cambridge, Massachusetts")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0